module.exports = ["Anant Mishra","Ananya Bahadur","Arjun Singh","Ashish Singh","Gopal Shimpi","Jyoti Gautam","Jaypal Kadam","Pankaj Rawat","Raman Sah","Sagar Karwande","Vikram Jadon"]


//////////////////
// WEBPACK FOOTER
// ./content/acknowledgements.yml
// module id = 489
// module chunks = 159071680842142